module.exports = __webpack_public_path__ + "static/media/zwzhome1.07964a96.jpg";